import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import config from '../../config';
import { getActiveFiltersCount } from './utils/filters';
import { formatCounter } from '../../utils/formatCounter';
import { FILTERS_UPDATED_EVENT } from '../../constants/events';

export function FiltersCount() {
  // счётчик живёт в localStorage — обновляем его по событию сохранения фильтров,
  // иначе бейдж в топбаре не сбрасывается до следующего перехода
  const [count, setCount] = useState(getActiveFiltersCount());

  useEffect(() => {
    const updateCount = () => setCount(getActiveFiltersCount());

    window.addEventListener(FILTERS_UPDATED_EVENT, updateCount);

    return () => window.removeEventListener(FILTERS_UPDATED_EVENT, updateCount);
  }, []);

  return (
    <Link className="relative" to={config.ROUTES.FILTERS}>
      <img src="/icons/Button-filters.svg" className="size-[44px] flex-shrink-0 cursor-pointer" />
      {count > 0 && (
        <div className="absolute -top-0.5 -right-0.5 bg-[#A1F69E] text-black rounded-full min-w-[16px] h-[16px] flex items-center justify-center text-[10px] font-bold px-1">
          {formatCounter(count)}
        </div>
      )}
    </Link>
  );
}
